import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HarvestAndPlantingLegend from '../HarvestAndPlantingLegend';
import { getCurrentSeason } from '../../../../selectors';

export function PlantingLegend(props) {
  return <HarvestAndPlantingLegend {...props} />;
}

PlantingLegend.propTypes = {
  dates: PropTypes.object.isRequired,
};

export function mapStateToProps(state, props) {
  const activeSeason = getCurrentSeason(state, props);
  const { list } = state.seasons;
  const { plantingEndDate, plantingStartDate, plantingYear } =
    list?.[activeSeason] ?? {};
  const dates = {
    endDate: plantingEndDate,
    startDate: plantingStartDate,
    year: plantingYear,
  };

  return {
    dates,
  };
}

export default connect(mapStateToProps)(PlantingLegend);
